import { mangaList } from '@/mocks/mangaData';

const phoneBooks = mangaList.slice(0, 3);

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=A%20dreamy%20wide%20anime%20illustration%20of%20a%20cherry%20blossom%20street%20in%20soft%20morning%20light%2C%20rows%20of%20blooming%20pink%20sakura%20trees%20with%20petals%20drifting%20in%20the%20breeze%2C%20gentle%20sunbeam%20rays%20through%20branches%2C%20soft%20pastel%20pink%20white%20and%20cream%20palette%2C%20peaceful%20ethereal%20atmosphere%2C%20clean%20stylized%20anime%20background%20art%2C%20smooth%20gradient%20sky&width=1600&height=1000&seq=hero-sakura-street&orientation=landscape')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-background-50" />

      <div className="relative mx-auto max-w-7xl px-4 pt-28 pb-16 text-center md:px-6 md:pt-40">
        <div className="mx-auto flex w-full max-w-3xl flex-col items-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-xs font-medium text-white ring-1 ring-white/30 backdrop-blur-sm">
            <i className="ri-flashlight-line text-sm" />
            追更不怕漏 · 更新第一时间提醒
          </span>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-white sm:text-4xl md:text-5xl lg:text-6xl">
            樱花漫画
            <span className="mt-3 block text-xl font-semibold text-white/90 sm:text-2xl md:text-3xl">
              追更提醒 · 缓存下载 · 收藏订阅
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-white/90 sm:text-base">
            收藏订阅、书架管理，追更进度自动同步；缓存章节随时读，通勤路上也能看。
            更新第一时间提醒，让你喜欢的每一部作品都不错过。
          </p>

          <div className="mt-8 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row">
            <a
              href="#guide"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-8 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-rocket-2-line text-base" />
              免费开始追更
            </a>
            <a
              href="#features"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-white/15 px-8 py-3.5 text-sm font-semibold text-white ring-1 ring-white/40 backdrop-blur-sm transition-colors hover:bg-white/25 sm:w-auto"
            >
              了解核心功能
              <i className="ri-arrow-down-line text-base" />
            </a>
          </div>

          <div className="mt-10 grid w-full max-w-2xl grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-4">
            {[
              { num: '12万+', label: '追更用户' },
              { num: '3万+', label: '收录作品' },
              { num: '99.9%', label: '提醒准确率' },
              { num: '4.9', label: '用户评分' },
            ].map((s) => (
              <div key={s.label} className="flex flex-col items-center">
                <span className="font-heading text-2xl font-bold text-white md:text-3xl">
                  {s.num}
                </span>
                <span className="mt-1 text-xs text-white/80">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 手机追更界面 mockup */}
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative z-10 mx-auto w-[300px] max-w-full rounded-[2rem] bg-foreground-950 p-3 shadow-2xl ring-1 ring-white/20 sm:w-[320px]">
          <div className="relative overflow-hidden rounded-[1.5rem] bg-background-50">
            <div className="flex items-center justify-between px-4 pt-4 pb-2">
              <div>
                <p className="text-xs text-foreground-500">我的书架</p>
                <p className="text-sm font-bold text-foreground-950">追更中 · 12 部</p>
              </div>
              <div className="flex items-center gap-3 text-foreground-700">
                <i className="ri-search-line text-base" />
                <i className="ri-notification-3-line relative text-base">
                  <span className="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-accent-500" />
                </i>
              </div>
            </div>

            <div className="flex flex-col gap-2.5 px-4 pb-4">
              {phoneBooks.map((book, idx) => (
                <div
                  key={book.id}
                  className="flex items-center gap-3 rounded-2xl bg-background-100 p-2.5"
                >
                  <img
                    src={book.cover}
                    alt={`${book.title}封面`}
                    className="h-14 w-10 shrink-0 rounded-lg object-cover object-top"
                  />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center justify-between">
                      <p className="truncate text-xs font-semibold text-foreground-950">
                        {book.title}
                      </p>
                      {idx === 0 ? (
                        <span className="inline-flex shrink-0 items-center rounded-full bg-primary-500 px-2 py-0.5 text-[10px] font-semibold text-background-50">
                          已更新
                        </span>
                      ) : (
                        <span className="shrink-0 text-[10px] text-foreground-400">已缓存</span>
                      )}
                    </div>
                    <div className="mt-1.5 flex items-center gap-2">
                      <div className="h-1 flex-1 overflow-hidden rounded-full bg-background-200">
                        <div
                          className="h-full rounded-full bg-primary-400"
                          style={{ width: `${[72, 45, 88][idx]}%` }}
                        />
                      </div>
                      <span className="text-[10px] text-foreground-500">
                        {[72, 45, 88][idx]}%
                      </span>
                    </div>
                  </div>
                </div>
              ))}

              <div className="mt-1 grid grid-cols-3 gap-2 text-center">
                <div className="rounded-xl bg-background-100 py-2">
                  <p className="text-xs font-semibold text-foreground-950">最新</p>
                  <p className="text-[10px] text-foreground-500">今日更新</p>
                </div>
                <div className="rounded-xl bg-background-100 py-2">
                  <p className="text-xs font-semibold text-foreground-950">书架</p>
                  <p className="text-[10px] text-foreground-500">我的收藏</p>
                </div>
                <div className="rounded-xl bg-background-100 py-2">
                  <p className="text-xs font-semibold text-foreground-950">缓存</p>
                  <p className="text-[10px] text-foreground-500">离线可用</p>
                </div>
              </div>
            </div>

            <div className="border-t border-background-200 px-4 py-2">
              <div className="flex items-center justify-between text-foreground-400">
                <i className="ri-book-3-line text-lg" />
                <i className="ri-heart-3-line text-lg text-primary-400" />
                <i className="ri-download-2-line text-lg" />
                <i className="ri-user-3-line text-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}